import { useState } from 'react';
import FilterBar, { FilterSummary, defaultFilters, type FilterState } from '@/components/feature/FilterBar';
import { SORT_OPTIONS } from '@/mocks/movies';

interface MobileFilterProps {
  genres: string[];
  filters: FilterState;
  onChange: (patch: Partial<FilterState>) => void;
  resultCount: number;
}

export default function MobileFilter({ genres, filters, onChange, resultCount }: MobileFilterProps) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<FilterState>(filters);

  const openPanel = () => {
    setDraft(filters);
    setOpen(true);
  };

  return (
    <div className="lg:hidden">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={openPanel}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-800"
        >
          <i className="ri-filter-3-line w-4 h-4 flex items-center justify-center" />
          筛选
          <span className="rounded-full bg-primary-500 px-1.5 text-[10px] text-background-50">{resultCount}</span>
        </button>
        <div className="no-scrollbar flex flex-1 gap-1.5 overflow-x-auto">
          {SORT_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange({ sort: option.value })}
              className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] transition ${
                filters.sort === option.value ? 'bg-primary-100 font-medium text-primary-800' : 'bg-background-100 text-foreground-600'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {open && (
        <div className="fixed inset-0 z-[60] flex items-end bg-background-950/50" onClick={() => setOpen(false)}>
          <div className="max-h-[82vh] w-full overflow-y-auto rounded-t-xl bg-background-50 p-4" onClick={(event) => event.stopPropagation()}>
            <div className="mb-2 flex items-center justify-between">
              <h3 className="font-heading text-base font-bold text-foreground-950">筛选条件</h3>
              <button type="button" onClick={() => setOpen(false)} aria-label="关闭筛选" className="flex h-8 w-8 items-center justify-center rounded-md bg-background-100 text-foreground-600">
                <i className="ri-close-line text-lg" />
              </button>
            </div>
            <FilterBar
              genres={genres}
              filters={draft}
              onChange={(patch) => setDraft((prev) => ({ ...prev, ...patch }))}
            />
            <div className="mt-3 flex gap-2">
              <button
                type="button"
                onClick={() => setDraft(defaultFilters)}
                className="flex-1 whitespace-nowrap rounded-md border border-background-300 py-2.5 text-sm text-foreground-700"
              >
                重置
              </button>
              <button
                type="button"
                onClick={() => {
                  onChange(draft);
                  setOpen(false);
                }}
                className="flex-1 whitespace-nowrap rounded-md bg-primary-500 py-2.5 text-sm font-medium text-background-50"
              >
                查看结果
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export { FilterSummary };